module.exports = "/_next/static/images/rabbit-84953ce9b682e17fe12c74cdd3a893b1.png";